"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChartWidgetComponent = void 0;
const react_1 = __importDefault(require("react"));
const DropdownWidgetComponent_1 = __importDefault(require("../DropdownWidgetComponent"));
const CsvBuilder_1 = __importDefault(require("../../CsvBuilder"));
const ActionCancelModalComponent_1 = __importDefault(require("@mwater/react-library/lib/ActionCancelModalComponent"));
const ChartViewComponent_1 = __importDefault(require("./ChartViewComponent"));
const ModalWindowComponent_1 = __importDefault(require("@mwater/react-library/lib/ModalWindowComponent"));
const ui = __importStar(require("@mwater/react-library/lib/bootstrap"));
const expressions_ui_1 = require("@mwater/expressions-ui");
const layoutOptions_1 = require("../../dashboards/layoutOptions");
// Complete chart widget
class ChartWidgetComponent extends react_1.default.PureComponent {
    static contextType = expressions_ui_1.LocaleContext;
    constructor(props) {
        super(props);
        this.state = {
            // Design that is being edited. Change is propagated on closing window
            editDesign: null
        };
    }
    // Saves a csv file to disk
    handleSaveCsvFile = () => {
        // Get the data
        return this.props.widgetDataSource.getData(this.props.design, this.props.filters, (err, data) => {
            if (err) {
                return alert(T `Failed to get data: ${err.message}`);
            }
            // Create data table
            const table = this.props.chart.createDataTable(this.props.design, this.props.schema, this.props.dataSource, data, this.context);
            if (!table) {
                return;
            }
            // Convert to csv
            let csv = new CsvBuilder_1.default().build(table);
            // Add BOM
            csv = "\uFEFF" + csv;
            // Make a blob and save
            const blob = new Blob([csv], { type: "text/csv" });
            // Require at use as causes server problems
            const FileSaver = require("file-saver");
            return FileSaver.saveAs(blob, "Exported Data.csv");
        });
    };
    // Saves an xlsx file to disk
    handleSaveXlsxFile = () => {
        // Get the data
        this.props.widgetDataSource.getData(this.props.design, this.props.filters, (err, data) => {
            if (err) {
                console.error(err);
                alert(T `Failed to get data: ${err.message}`);
                return;
            }
            try {
                // Create workbook
                const blob = this.props.chart.createXlsxWorkbook(this.props.design, this.props.schema, this.props.dataSource, data, this.context);
                // Require at use as causes server problems
                const FileSaver = require("file-saver");
                FileSaver.saveAs(blob, "Exported Data.xlsx");
            }
            catch (ex) {
                console.error(ex);
                alert(T `Failed to export data: ${ex.message}`);
            }
        });
    };
    handleStartEditing = () => {
        // Can't edit if already editing
        if (this.state.editDesign) {
            return;
        }
        this.setState({ editDesign: this.props.design });
    };
    handleEndEditing = () => {
        this.props.onDesignChange(this.state.editDesign);
        this.setState({ editDesign: null });
    };
    handleCancelEditing = () => {
        this.setState({ editDesign: null });
    };
    handleEditDesignChange = (design) => {
        this.setState({ editDesign: design });
    };
    renderChart(design, onDesignChange, width, height) {
        return react_1.default.createElement(ChartViewComponent_1.default, { chart: this.props.chart, design: design, onDesignChange: onDesignChange, schema: this.props.schema, dataSource: this.props.dataSource, widgetDataSource: this.props.widgetDataSource, scope: this.props.scope, filters: this.props.filters, width: width, height: height, onScopeChange: this.props.onScopeChange, onRowClick: this.props.onRowClick, refreshKey: this.props.refreshKey, locale: this.props.locale, translate: this.props.translate });
    }
    renderEditor() {
        if (!this.state.editDesign) {
            return null;
        }
        // Create editor
        const editor = this.props.chart.createDesignerElement({
            schema: this.props.schema,
            filters: this.props.filters,
            dataSource: this.props.dataSource,
            design: this.state.editDesign,
            onDesignChange: this.handleEditDesignChange
        });
        if (this.props.chart.hasDesignerPreview()) {
            // Create chart (maxing out at half of width of screen)
            const chartWidth = Math.min(document.body.clientWidth / 2, this.props.width);
            const chartHeight = this.props.height != null ? this.props.height * (chartWidth / this.props.width) : undefined;
            let chart = this.renderChart(this.state.editDesign, (design) => this.setState({ editDesign: design }), chartWidth, chartHeight);
            const content = (react_1.default.createElement("div", { style: { height: "100%", width: "100%" } },
                react_1.default.createElement(layoutOptions_1.BlocksLayoutOptionsContext.Consumer, null, blocksLayoutOptions => (react_1.default.createElement("style", { dangerouslySetInnerHTML: { __html: (0, layoutOptions_1.createDashboardStyles)("#chart-editor", blocksLayoutOptions || (0, layoutOptions_1.getDefaultLayoutOptions)()) } }))),
                react_1.default.createElement("div", { style: {
                        position: "absolute",
                        left: 0,
                        top: 0,
                        border: "solid 2px #EEE",
                        borderRadius: 8,
                        padding: 10,
                        width: chartWidth + 20,
                        height: chartHeight != null ? chartHeight + 20 : undefined,
                        overflow: "hidden"
                    }, id: "chart-editor" }, chart),
                react_1.default.createElement("div", { style: { width: "100%", height: "100%", paddingLeft: chartWidth + 40 } },
                    react_1.default.createElement("div", { style: {
                            width: "100%",
                            height: "100%",
                            overflowY: "auto",
                            paddingLeft: 20,
                            paddingRight: 20,
                            borderLeft: "solid 3px #AAA"
                        } }, editor))));
            return (react_1.default.createElement(ModalWindowComponent_1.default, { isOpen: true, onRequestClose: this.handleEndEditing }, content));
        }
        else {
            return (react_1.default.createElement(ActionCancelModalComponent_1.default, { size: "large", onCancel: this.handleCancelEditing, onAction: this.handleEndEditing }, editor));
        }
    }
    // Render a link to start editing
    renderEditLink(message) {
        return (react_1.default.createElement("div", { className: "mwater-visualization-widget-placeholder", onClick: this.handleStartEditing },
            react_1.default.createElement(ui.Icon, { id: this.props.chart.getPlaceholderIcon() }),
            react_1.default.createElement("div", { className: "mwater-visualization-widget-placeholder-message" }, message)));
    }
    render() {
        const design = this.props.chart.cleanDesign(this.props.design, this.props.schema);
        // Determine if valid design
        const designError = this.props.chart.validateDesign(design, this.props.schema);
        // Determine if empty
        const emptyDesign = this.props.chart.isEmpty(design);
        // Create dropdown items
        const dropdownItems = this.props.chart.createDropdownItems(design, this.props.schema, this.props.widgetDataSource, this.props.filters);
        if (!designError) {
            dropdownItems.push({ label: T `Export Data (CSV)`, onClick: this.handleSaveCsvFile });
            // Add XLSX export option if supported
            if (this.props.chart.supportsXlsxExport()) {
                dropdownItems.push({ label: T `Export Data (XLSX)`, onClick: this.handleSaveXlsxFile });
            }
        }
        if (this.props.onDesignChange != null) {
            dropdownItems.unshift({
                label: this.props.chart.getEditLabel(),
                onClick: this.handleStartEditing
            });
        }
        // Wrap in a simple widget
        return (react_1.default.createElement("div", { onDoubleClick: this.props.onDesignChange != null ? this.handleStartEditing : undefined, style: { position: "relative", width: this.props.width } },
            this.props.onDesignChange != null ? this.renderEditor() : undefined,
            react_1.default.createElement(DropdownWidgetComponent_1.default, { width: this.props.width, height: this.props.height, dropdownItems: dropdownItems }, this.renderChart(design, this.props.onDesignChange, this.props.width, this.props.height)),
            (emptyDesign || designError) && this.props.onDesignChange != null ? this.renderEditLink(designError || "") : undefined));
    }
}
exports.ChartWidgetComponent = ChartWidgetComponent;
